// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1iwxG","list":"PatternAutocomplete_list__3Flw9"};